export default "__VITE_ASSET__BGMci9eC__"